import React from 'react'
const TwitterIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.46 5.76c-.8.36-1.66.6-2.56.7a4.53 4.53 0 0 0 1.98-2.5 9.05 9.05 0 0 1-2.87 1.1A4.52 4.52 0 0 0 14.07 4c-2.5 0-4.53 2.03-4.53 4.52 0 .36.04.7.1 1.03-3.77-.2-7.1-2-9.36-4.76a4.63 4.63 0 0 0-.62 2.32c0 1.6.8 3 2.02 3.82a4.53 4.53 0 0 1-2.05-.56v.06c0 2.23 1.57 4.1 3.66 4.53-.38.1-.8.16-1.23.16-.3 0-.6-.03-.9-.1.6 1.8 2.3 3.1 4.3 3.14a9.1 9.1 0 0 1-5.62 1.94c-.36 0-.7-.03-1.03-.1 2.03 1.3 4.45 2.03 7.1 2.03 8.52 0 13.17-7.05 13.17-13.17 0-.2 0-.4-.03-.6.9-.66 1.68-1.46 2.3-2.38z"
        fill="#1DA1F2"
      />
    </svg>
  )
}

export default TwitterIcon
